import styled from '@emotion/styled'

export const ArticleShareLinksItem = styled.a`
  color: var(--c-gray500);

  &[visited],
  &[active] {
    color: var(--c-gray500);
  }
`
